import React, { useContext } from 'react'
import {Link} from "react-router-dom"
import MyButton from '../button/MyButton'
import { AuthContext } from '../../../context'

function Navbar() {
  const {isAuth,setIsAuth} = useContext(AuthContext)
  const logout= () => {
    setIsAuth(false)
    localStorage.removeItem('auth')
  }

  return(
    <div className='navbar'>
      <img src="http://vuejs-map.vladzolo.fr/img/logo-zolv.fb859b3b.png" width="41" height="41" alt="zolv"></img>
      <MyButton style={{marginLeft: '15px'}} onClick={logout}>
        Deconnection
      </MyButton>
      <nav className='navbar__links'>
        <Link to='/about' style={{marginRight: '15px'}}><MyButton>About App</MyButton></Link>
        <Link to='/models'><MyButton>Models</MyButton></Link>
      </nav>
    </div>
  )
}

export default Navbar
